// extracted by mini-css-extract-plugin
module.exports = {"organization-structure__card":"_1xTJhtlB7Exm4UJ-Jc35X0"};